export const DEFAULT_CAROUSEL_VIEW_INFO_MSG = {
    id: 'oe.defaultPage.defaultCarouselViewInfoMsg',
    defaultMessage: `
    If the carousel is set to ‘Collapsed’ by default, three session cards will be displayed, and the user can scroll to the right to see more, 
    or they can click ‘Show All’ to stack the cards in rows of 3 and scroll vertically to view them. 
    If ‘Show All’ is the default, then the stacked view will be shown by default, and the user can click ‘Collapse’ 
    to reduce the carousel back to a single row of three cards.`,
    description: 'Default carousel view info message'
};

export const SESSION_HOST_ATTENDEES_TOGGLE_TEXT = {
    message: 'Display Host attendees is {suffix}',
    id: 'oe.defaultPage.sessionHostAttendeesEnabled',
    description: 'Label text'
};

export const JOIN_SESSIONS_WITH_PREREGISTERING_TEXT = {
    message: 'Enforced pre-registration before attendees can join sessions is enabled',
    id: 'oe.defaultPage.joinSessionsWithPreregistering',
    description: 'Label text'
};

export const JOIN_SESSIONS_WITHOUT_PREREGISTERING_TEXT = {
    message: 'Enforced pre-registration before attendees can join sessions is disabled',
    id: 'oe.defaultPage.joinSessionsWithoutPreregistering',
    description: 'Label text'
};

export const ACCESS_TO_GENERAL_SESSIONS_RESTRICTED_TEXT = {
    message: 'Access to General Sessions page is restricted',
    id: 'oe.defaultPage.accessToGeneralSessionsRestricted',
    description: 'Label text'
};

export const ACCESS_TO_GENERAL_SESSIONS_NOT_RESTRICTED_TEXT = {
    message: 'Access to General Sessions page is not restricted',
    id: 'oe.defaultPage.accessToGeneralSessionsNotRestricted',
    description: 'Label text'
};

export const ACCESS_TO_GENERAL_SESSIONS_DESCRIPTION_TEXT = {
    message: `When access to General Sessions page is restricted, attendees will only have access to the General Sessions page
     if they match all the criteria of at least one filter.`,
    id: 'oe.defaultPage.accessToGeneralSessionsDescription',
    description: 'Label text'
};

export const SUBSCRIBE_ON_REGISTRATION_TEXT = {
    message: 'Subscribe attendee to meeting on registration is {suffix}',
    id: 'oe.defaultPage.subscribeOnRegistrationEnabled',
    description: 'Label text'
};